import { jsx as e } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import { TextPrimitive as f } from "./index.es761.js";
const x = m(
  ({ size: o = "default", ...r }, t) => /* @__PURE__ */ e(f, { ...r, type: "body", role: "body-text", size: o, ref: t })
);
export {
  x as BodyText
};
//# sourceMappingURL=index.es487.js.map
